module.exports = __webpack_public_path__ + "img/WindImGesicht.b3d14f75.jpg";